// Pricing gate derived from the Guardrail safety score.
// The backend decides the mode (guardrail/safety.py::pricing_gate); the UI
// only renders it. Anything below "exact" must be visually recognisable as
// non-final: never the same size/colour as a firm price.

export const GATE_STYLES = {
  exact: {
    border: "border-blue-500/50",
    text: "text-blue-400",
    size: "text-2xl",
    chip: "border-blue-500/40 bg-blue-500/10 text-blue-300",
  },
  preliminary: {
    border: "border-cyan-500/40 border-dashed",
    text: "text-cyan-300",
    size: "text-lg",
    chip: "border-cyan-500/40 bg-cyan-500/10 text-cyan-300",
  },
  rough: {
    border: "border-amber-500/40 border-dashed",
    text: "text-amber-300",
    size: "text-base",
    chip: "border-amber-500/40 bg-amber-500/10 text-amber-300",
  },
  blocked: {
    border: "border-rose-500/50 border-dashed",
    text: "text-rose-300",
    size: "text-base",
    chip: "border-rose-500/40 bg-rose-500/10 text-rose-300",
  },
};

export function priceGate(guardrail) {
  const mode = guardrail?.pricing_mode || "exact";
  const band = guardrail?.price_range_pct || { low_pct: 0, high_pct: 0 };
  return {
    mode,
    band,
    blocked: mode === "blocked",
    exact: mode === "exact",
    styles: GATE_STYLES[mode] || GATE_STYLES.exact,
    score: typeof guardrail?.safety_score === "number" ? guardrail.safety_score : null,
  };
}

export function priceRange(total, band) {
  const v = Number(total) || 0;
  return {
    low: v * (1 + (band?.low_pct || 0) / 100),
    high: v * (1 + (band?.high_pct || 0) / 100),
  };
}
